export default {
    PROFILE_SUPERADMIN: 'SUPERADMIN',
    PROFILE_ADMIN: 'ADMIN',
    PROFILE_ADMIN_ETABLISSEMENT: 'ADMIN_ETABLISSEMENT',
    PROFILE_CSA: 'CSA',
    PROFILE_DAP: 'DAP',
    PROFILE_DAJ: 'DAJ',
    PROFILE_EDITION: 'EDITION',
    PROFILE_RECTEUR: 'RECTEUR'
};
